import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activity-spinner',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './activity-spinner.component.html'
})
export class ActivitySpinnerComponent {
  @Input() color = '#E5E7EB';
  @Input() size = '16px';
}
